<template>
  <p
    class="error-message-parts"
    v-if="showError"
    :class="{ 'error-message-parts--hidden': !showError }"
  >
    {{ message }}
  </p>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * エラーメッセージ表示
 */
export default defineComponent({
  props: {
    /**
     * エラーを表示するかどうか
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * 表示するメッセージ
     */
    message: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.error-message-parts {
  display: inline-flex;
  padding: 0.2em 0.8em;
  text-align: left;
  margin-top: 0.4em;
  color: $black;
  font-size: 0.7143em;
  background: $red-light;
  border-radius: 1.6em;
  letter-spacing: 0.04em;

  &--hidden {
    visibility: hidden;
  }
}
</style>
